import * as types from '@/store/mutation-types'

const state = {
    sidebar: false
}

const getters = {
    sidebar: state => state.sidebar
}

const mutations = {
    [types.SIDE_BAR](state, value) {
        state.sidebar = value
    }
}

export default {
    state,
    getters,
    mutations
}
